export default {
  title: "Invoice Details",
    back: "Back",
    invoiceNumber: "Invoice Number",
    userInfo: "User Information",
    invoiceInfo: "Invoice Information",
    addressInfo: "Address Information",
    fullName: "Full Name",
    mobile: "Mobile",
    school: "School",
    orderId: "Order ID",
    shippingMethod: "Shipping Method",
    paymentMethod: "Payment Method",
    receiverPhone: "Receiver Phone",
    city: "City",
    postalCode: "Postal Code",
    items: "Invoice Items",
    product: "Product",
    quantity: "Quantity",
    price: "Price",
    discount: "Discount",
    tax: "Tax",
    total: "Total",
    subtotal: "Subtotal",
    totalDiscount: "Total Discount",
    shippingCost: "Shipping Cost",
    totalPrice: "Total Price",
     address: "Address",          // اضافه شد
    addressDetails: "Details",   // اضافه شد
};
